import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../store/modules/scholars";

import TopNav from "../../../admin/etc/tab";
import {getParams, pushUrl} from "../../../../utils/functions";

import * as func from "../../../../utils/functions";

import DefaultForm from "./0_defaultForm";
// import IdForm from "./1_Name_ID";
import ABForm from "./1_ABForm";
import IntroForm from "./2_IntroForm";
// import CommunicationForm from "./3_CommunicationForm";
// import RecordList from "./form/record";

const arr = ["기본정보", "메타정보"];
const arr2 = ["기본정보"];

const vObj = {
	0 : <DefaultForm />,
	// 1 : <IdForm />,
	1 : <ABForm />,
	// 2 : <IntroForm />,
  // 3 : <Record />,
}

class Scontent extends Component {
	constructor(props) {
		super(props);

		const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

		this.state = {
			activeTab: activeTabID === null ? 0 : activeTabID,
			isInit: false
		};

		this.showHide = this.showHide.bind(this)
	}

	componentDidMount() {
		// let tempRecord = {
		// 	'resource_title': "",
		// 	'resource_title_translation': "",
		// 	'journal_title': "",
		// 	'issue': "",
		// 	'registered_db': "",
		// 	'journal_category': "",
		// 	'publish_year': "",
		// 	'volume': "",
		// 	'issue': "",
		// 	'start_page': "",
		// 	'end_page': "",
		// 	'total_page': "",
		// 	'indicator_year': "",
		// 	'input_date': ""
		// }

		// if (!func.getParams("record_id")) {
		// 	this.props.dataActions.setResource({"record": tempRecord});

		// 	if (!this.state.isInit) {
		// 		this.setState({
		// 			isInit: true,
		// 		})
		// 	}
		// } else 
    
    if (func.getParams("record_id")) {
			func.getData("admin/scholar/" + func.getParams("record_id"), null).then((response) => {

				if (response) {
					this.props.dataActions.setScholar(response)
				}

				if (!this.state.isInit) {
					this.setState({
						isInit: true,
					})
				}
			});
		} else if (!this.state.isInit) {
			this.setState({
				isInit: true,
			})
		}
	}

	updateValue = (id) => {
		this.setState({
			activeTab: id
		});

		const url = func.changeParamUrl('tab_id', id)

		pushUrl('탭', url, null);
	}

	showHide () {
		let status = this.props.showSide === 'true' ? 'false' : 'true'
		func.setCookie('side', status, 999)
		this.props.dataActions.setScholar({'showSide' : status});
	}

	render() {
		return (
			<div className="col pl-0 detail scholar-detail">
				{this.state.isInit &&
				<>
					<div className="detail-tabs">
						<TopNav
							tabList={this.props.record.scholar_id ? arr : arr2}
							changeTab={this.updateValue}
							activeID={this.state.activeTab}
						/>
						{this.props.showSide !== 'false' &&
						<span className="hide-side-list full-screen-icon" onClick={this.showHide}/>
						}
						{this.props.showSide === 'false' &&
						<span className="view-side-list list-icon" onClick={this.showHide}/>
						}
					</div>
					<div className="detail-content">
						{vObj[this.state.activeTab]}
					</div>
				</>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
		showSide : state.scholars.showSide ? state.scholars.showSide  : 'true'
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
	}),
)(Scontent)